











import Vue from 'vue';
import CopyrightPanel from '@/components/Common/CopyrightPanel.vue';

export default Vue.extend({
    name: 'AuthLayout',
    components: {
        CopyrightPanel,
    },
});
